import React, {useContext, useEffect, useState} from 'react';
import {Dialog, DialogTitle, DialogContent, Tabs, Tab, Box, Typography} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from '@mui/icons-material/Person';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ChecklistIcon from '@mui/icons-material/Checklist';
import DescriptionIcon from '@mui/icons-material/Description';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

import Profile from "./Profile";
import Notifications from "./Notifications";
import Essentials from "./Essentials";
import Documents from "./Documents";
import Transactions from "./Transactions";
import {PAContext} from "../../../Services/PAContext";


function AccountDialog({ isOpen, onClose }){



    const { dataArray, sendSocketMessage, updateGlobalAccount, removeFirstAccountActions } = useContext(PAContext);
    const { Account, IncomingAccountActions } = dataArray;

    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    const [ processingProfile, setProcessingProfile ] = useState(false);
    const [ processingNotifications, setProcessingNotifications ] = useState(false);

    useEffect(() => {

        if (!IncomingAccountActions || IncomingAccountActions.length === 0) return;

        // 2. Process the most recent action (or loop safely)
        const processActions = () => {
            IncomingAccountActions.forEach((_incoming) => {
                console.log('Processing action:', _incoming.action);

                if (_incoming.result === "ok") {
                    // Handle Profile Updates
                    if (_incoming.action === "E_updateAccountPersonalInfoResults") {
                        if (Account.id === _incoming.attendee_id) {
                            // ✅ CORRECT: Use a functional update to merge fields
                            // Assuming updateGlobalAccount is your context's setter
                            updateGlobalAccount({
                                ..._incoming.updatedFields // The fields returned from your server
                            });
                        }
                        setProcessingProfile(false);
                        setSnackbar({ open: true, message: 'Profile Updated', severity: 'success' });
                    }

                    // Handle Auto-Login Toggle
                    else if (_incoming.action === "E_updateAccountPersonalInfoAutoLoginResults") {
                        updateGlobalAccount({
                            ..._incoming.updatedFields // The fields returned from your server
                        });
                        setSnackbar({open: true, message: 'Auto-login setting updated', severity: 'success'});
                    }
                    // Handle PASSWORD update
                    else if (_incoming.action === "E_updateAccountPersonalInfoPasswordResults") {
                            updateGlobalAccount({
                                ..._incoming.updatedFields // The fields returned from your server
                            });
                            setSnackbar({ open: true, message: 'Password updated successfully!', severity: 'success' });
                    }
                    // Handle NOTIFICATIONS update
                    else if (_incoming.action === "E_updateAccountPersonalInfoNotificationsResults") {
                        updateGlobalAccount({
                            ..._incoming.updatedFields // The fields returned from your server
                        });
                        setProcessingNotifications(false);
                        setSnackbar({ open: true, message: 'Notifications updated successfully!', severity: 'success' });
                    }

                } else {
                    // Handle Errors
                    setSnackbar({
                        open: true,
                        message: _incoming.reason || 'An error occurred',
                        severity: 'error'
                    });
                }

                // 3. ✅ Move this inside the loop or use a "clear all" function
                removeFirstAccountActions();
            });
        };

        processActions();

    }, [IncomingAccountActions, Account.id]);
    /**
     * Custom TabPanel component for managing view switching
     */
    function CustomTabPanel(props) {
        const { children, value, index, ...other } = props;
        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`account-tabpanel-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ p: 2 }}>
                        {children}
                    </Box>
                )}
            </div>
        );
    }

    const [tabValue, setTabValue] = useState(0);
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };



    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: { borderRadius: '16px', minHeight: '600px' }
            }}
        >

            <DialogTitle sx={{ m: 0, p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography component="div" variant="h6" sx={{ fontWeight: 700 }}>
                    Account Settings
                </Typography>
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}
            >
                <Tab icon={<PersonIcon />} label="Profile" iconPosition="start" />
                <Tab icon={<NotificationsIcon />} label="Notifications" iconPosition="start" />
                <Tab icon={<ChecklistIcon />} label="Essentials" iconPosition="start" />
                <Tab icon={<DescriptionIcon />} label="Documents" iconPosition="start" />
                <Tab icon={<ReceiptLongIcon />} label="Transactions" iconPosition="start" />
            </Tabs>

            <DialogContent sx={{ p: 0 }}>

                {/* 1. PROFILE TAB */}
                <CustomTabPanel value={tabValue} index={0}>
                    <Profile
                        processingProfile={processingProfile}
                        setProcessingProfile={setProcessingProfile}
                        snackbar={snackbar}
                        setSnackbar={setSnackbar}
                    />
                </CustomTabPanel>

                {/* 2. NOTIFICATIONS TAB */}
                <CustomTabPanel value={tabValue} index={1}>
                    <Notifications
                        processingNotifications={processingNotifications}
                        setProcessingNotifications={setProcessingNotifications}
                        snackbar={snackbar}
                        setSnackbar={setSnackbar}
                    />
                </CustomTabPanel>

                {/* 3. ESSENTIALS TAB (PACKING) */}
                <CustomTabPanel value={tabValue} index={2}>
                    <Essentials />
                </CustomTabPanel>

                {/* 4. DOCUMENTS TAB */}
                <CustomTabPanel value={tabValue} index={3}>
                    <Documents />
                </CustomTabPanel>

                {/* 5. TRANSACTIONS TAB */}
                <CustomTabPanel value={tabValue} index={4}>
                    <Transactions />
                </CustomTabPanel>

            </DialogContent>

        </Dialog>

    )

}

export default AccountDialog;